function searchFunction() {
  var input, filter, ul, li, p, i, txtValue, not_found;
  input = document.getElementById("myInput");
  not_found = document.getElementById("not_found");
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = ul.getElementsByTagName("li");

  for (i = 0; i < li.length; i++) {
    p = li[i].getElementsByTagName("p")[0];
    txtValue = (p.textContent || p.innerText);
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "block";
    } else {
      li[i].style.display = "none";
      console.log("i", i, "li.lenght", li.length - 1, li[i]);
      if (i == li.length - 1) {
        document.getElementById("not_found").style.display = "block";
      } else {
        document.getElementById("not_found").style.display = "none";

      }
    }

  }
}
//markup for SplitTesting Help Centre Test
let newSTHelpMain = document.createElement('main');
newSTHelpMain.id = 'MainContent2';
newSTHelpMain.setAttribute('class','content-for-layout focus-none');
newSTHelpMain.setAttribute('role','main');
newSTHelpMain.setAttribute('tabindex','-1');
let newSTHelpContent = `
  <section id="shopify-section-template--14870472196138__4688f8d8-e089-4ec0-a0af-cba09d700bc5" class="shopify-section faq-search-section split_task_none">
    <div class="faq-search">
      <div class="search-box">
        <h2 class="title">frequently asked <br>questions</h2>
        <p>Search for your questions below. If you would like to see our delivery schedule, <a href="https://inspiredgo.ca/pages/faqs">click here</a>.</p>
        <form>
          <div class="field-group">
            <input type="text" id="myInput" onkeyup="searchFunction()" placeholder="Search for your queries">
            <div class="suggestion">
              <h5 class="title">Search Suggestion:</h5>
              <ul class="suggestion-list" id="myUL">
                <li>
                  <p><a href="#tab11">What cities do you deliver to?</a></p>
                </li>
                <li>
                  <p><a href="#tab12">How do I qualify for free delivery?</a></p>
                </li>
                <li>
                  <p><a href="#tab13">What is the minimum order?</a></p>
                </li>
                <li>
                  <p><a href="#tab14">How do I sign up for a subscription service?</a></p>
                </li>
                <li>
                  <p><a href="#tab15">If I order now, when will my delivery arrive?</a></p>
                </li>
                <li>
                  <p><a href="#tab16">What if I am not home when you make the delivery?</a></p>
                </li>
                <li>
                  <p><a href="#tab17">Can I get text message notifications about my order?</a></p>
                </li>
                <li>
                  <p><a href="#tab18">What if I live in an apartment?</a></p>
                </li>
                <li>
                  <p><a href="#tab19">Can I pick up my order?</a></p>
                </li>
                <li>
                  <p><a href="#tab110">What if I need to change my delivery address?</a></p>
                </li>
                <li>
                  <p><a href="#tab21">What do I do if I have an allergy?</a></p>
                </li>
                <li>
                  <p><a href="#tab22">Where can I find nutritional information of the meals?</a></p>
                </li>
                <li>
                  <p><a href="#tab23">What if I don't like an ingredient?</a></p>
                </li>
                <li>
                  <p><a href="#tab24">How big is each meal?</a></p>
                </li>
                <li>
                  <p><a href="#tab25">How long will my meals last?</a></p>
                </li>
                <li>
                  <p><a href="#tab31">What is the referral program?</a></p>
                </li>
                <li>
                  <p><a href="#tab32">What kind of packaging do you use for meals?</a></p>
                </li>
                <li>
                  <p><a href="#tab33">I have a product or service and want to partner with you. How do I reach out?</a></p>
                </li>
              </ul>
              <ul class="suggestion-list" id="not_found">
                <li>
                  <p><img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/not_found_icon_747249ee-a190-4728-a7ec-56cf108ff507.png?v=1672990284">There are no results for this query.</p>
                </li>
              </ul>
            </div>
            <button type="submit">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="#5C7261" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M23 23L16 16" stroke="#5C7261" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
          </div>
        </form>
      </div>
      <div class="image-box">
        <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/image_2_2.png?v=1672654167" alt="image">
      </div>
    </div>
  </section>
  <section id="shopify-section-template--14870472196138__c632289b-5b22-4cb3-870c-bdad51201f52" class="shopify-section faq-help-section split_task_none">
    <div class="faq-help">
      <h2 class="title">
        help centre
      </h2>
      <div class="faq-row">
        <div class="faq-column">
          <div class="card">
            <div class="image-box">
              <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/Group_43.png?v=1672661694" alt="iamge">
            </div>
            <div class="content">
              <h2 class="title">
                missing item
              </h2>
              <div class="description">
                <p>If you are missing an item from your order you can report it here. We are sorry we made an error! Thanks for helping us track these as we continue to improve!
                </p>
              </div>
              <a href="https://inspiredgo.typeform.com/to/gsxzqj6I?typeform-source=inspiredgo.ca" class="button">Report A Missing Item →</a>
            </div>
          </div>
        </div>
        <div class="faq-column">
          <div class="card">
            <div class="image-box">
              <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/Group_44.png?v=1672661694" alt="iamge">
            </div>
            <div class="content">
              <h2 class="title">
                delivery error
              </h2>
              <div class="description">
                <p>If you have received a text message letting you know your order has arrived but you have not received anything, let us know here! We will contact your delivery driver as soon as possible and let you know your order status!</p>
              </div>
              <a href="https://inspiredgo.typeform.com/to/yYZnjRYP?typeform-source=inspiredgo.ca" class="button">Report A Delivery Error →</a>
            </div>
          </div>
        </div>
        <div class="faq-column">
          <div class="card">
            <div class="image-box">
              <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/Group_45.png?v=1672661694" alt="iamge">
            </div>
            <div class="content">
              <h2 class="title">
                quality issue
              </h2>
              <div class="description">
                <p>If you received a meal that has a quality issue, we want to hear about it! We review all of the feedback weekly and work to make improvements and investigate issues. If you require a refund, we will process those based on your input in this form.
                </p>
              </div>
              <a href="https://inspiredgo.typeform.com/to/wR3twQn4?typeform-source=inspiredgo.ca" class="button">Report A Quality Issue →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="shopify-section-template--14870472196138__8e044661-fb91-4bc9-b664-0d6ea8c08b01" class="shopify-section faq_acc_section split_task_none">
    <div class="faq_accordion_wrapper split_task_none" id="faq_accordion_wrapper">
      <div class="container">
        <h2>frequently asked questions</h2>
        <div class="tab_top_list">
          <ul>
            <li id="tab1" class="active_tab"><a href="javascript:void(0)">Order &amp;<br>Delivery</a></li>
            <li id="tab2"><a href="javascript:void(0)">Nutrition<br>Information</a></li>
            <li id="tab3"><a href="javascript:void(0)">Other</a></li>
          </ul>
        </div>
        <div class="tab_list_content">
          <div class="tab_content active" data-id="tab1">
            <div class="accordion-container">
              <div class="set">
                <a href="javascript:void(0)" id="tab11">What cities do you deliver to?</a>
                <div class="content">
                  <p>We are currently delivering in Calgary, Edmonton, Winnipeg, the Greater Vancouver Area, Kelowna, Saskatoon, and Regina! This includes smaller cities surrounding Vancouver, Edmonton, Saskatoon, Kelowna, and Calgary. You can find a full list of our active cities by clicking <a href="https://inspiredgo.ca/pages/delivery-areas">here.</a></p>
                  <p>We are excited to expand! If you want Inspired Go where you are, please request your location through this form.</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab12">How do I qualify for free delivery?</a>
                <div class="content">
                  <p>We offer free deliverys on orders of $65 and up!</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab13">What is the minimum order?</a>
                <div class="content">
                  <p>We are so happy to be delivering to your doorstep. With this service, we require a $40 minimum purchase (4 meals) with each order. Our delivery fee is $6.95 for orders under $6.95. Between our salads, breakfast kits, healthy snacks, drinks and fresh add on options we are confident you will happily get to our minimum order amount!</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab14">How do I sign up for a subscription service?</a>
                <div class="content">
                  <p>To sign up, visit our menu, select your meals, and hit "Subscribe + Save" at checkout to sign up. Through our Subscription Service you are able to save 5% on every order, you can select the frequency that you want your orders to arrive, and you can adjust the items you receive each time.</p>
                  <p>Our service makes it easy to pause your orders from arriving, skip your delivery for the upcoming week, or cancel your subscription with a few mouse clicks. Learn more <a href="https://inspiredgo.ca/pages/subscriptioninfo">here.</a></p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab15">If I order now, when will my delivery arrive?</a>
                <div class="content">
                  <p>When checking out you will be able to select a delivery date from our calendar dropdown. Order before 10pm MST on your order cut-off date to receive your order on your prefered day. You can sign up for order reminders <a href="https://form.typeform.com/to/jDp62eBx?typeform-medium=embed-snippet#acceptsreminders=true">here.</a> You can ﬁnd our delivery schedule and order cut-offs <a href="https://inspiredgo.ca/pages/faq ">here.</a></p>
                  <p>The following windows are the times that we are out delivering orders in each city. You will receive an email before your delivery that will outline a smaller window that your order will arrive. You will also receive a text message 2 hours prior to your orders arrival, that notifies you your order is on its way, with a live tracker and a message when it arrives.</p>
                  <p>CALGARY: Mon, Fri: between 2pm &amp; 11pm |  Sun: between 11am &amp; 10pm</p>
                  <p>EDMONTON &amp; VANCOUVER: Sun, Mon, Tues: between 10am &amp; 10pm</p>
                  <p>SASKATOON &amp; WINNIPEG: Sun, Mon: between 10am &amp; 10pm</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab16">What if I am not home when you make the delivery?</a>
                <div class="content">
                  <p>Not a problem! We deliver in an insulated cooler with ice packs that will help protect your order from the elements. Our delivery bags and all meal packaging are 100% recyclable. We also text you order updates so you can watch for your order!</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab17">Can I get text message notifications about my order?</a>
                <div class="content">
                  <p>When we schedule your order, you will receive a text message to opt-in to receive updates about your order. We encourage you to reply "2" in order to receive updates for all future deliveries. This will ensure you do not miss any updates if your opt-in expires before you receive your order. Due to Canadian communication laws, when option 1 is selected the shortcode (text message) expires after 72 hours and often this will result in you not receiving any delivery text notiﬁcations for your delivery.</p>
                  <p>On the day of your scheduled delivery, you will receive a tracking link prior to your order being delivered. This tracking link is subject to change if delays occur so feel free to check in throughout the day. Minutes before your order arrives you will receive a second notiﬁcation letting you know the driver is arriving.</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab18">What if I live in an apartment?</a>
                <div class="content">
                  <p>Leave us your buzzer code and apartment number so that we know where to leave your delivery. It is best if you have your buzzer set up to let us in when we arrive so that we do not have to leave the order in the lobby. Any notes with your order are helpful!</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab19">Can I pick up my order?</a>
                <div class="content">
                  <p>We do not currently have a pick-up locations. We are working to expand delivery distribution so that we can deliver to your home instead!  You can submit a request for your location here and we will inform you when we have launched your location. Join our email list and stay tuned to our social media channels to hear more.</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab110">What if I need to change my delivery address?</a>
                <div class="content">
                  <p>Any changes made to your order, delivery day, or delivery location must be processed 4 days prior to your delivery date. You can ﬁnd our delivery schedule and order cut-offs here. We are unable to make any changes to your order after these cut-off dates have passed. We put the responsibility on you to ensure that you enter valid and up-to-date information when placing your order. This includes (but is not limited to): Address, Unit Number, Buzzer/Access Code, and Phone Number. Email us to process any changes to your order before the cut-off dates: <a href="mailto:info@inspiredgo.ca">info@inspiredgo.ca</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="tab_content" data-id="tab2">
            <div class="accordion-container">
              <div class="set">
                <a href="javascript:void(0)" id="tab21">What do I do if I have an allergy?</a>
                <div class="content">
                  <p>At Inspired Go we have processes and procedures in place to attempt to avoid cross contamination between ingredients. Risk of contamination is always possible and we encourage you to be diligent in understanding the severity of your allergy before placing an order and enjoying any Inspired Go meal. Allergens that we recognize within our menu are wheat, milk, egg, sulphites, nuts, sesame, soy, mustard, and fish. We outline the location of each allergen in the images of our meals to help you stay informed and make a buying decision.</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab22">Where can I find nutritional information of the meals?</a>
                <div class="content">
                  <p>Nutrition facts and complete breakdowns of the salad and the dressing can be found on our menu. Click on any image of a meal to ﬁnd more information. You can view nutritional information for all meals here.</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab23">What if I don't like an ingredient?</a>
                <div class="content">
                  <p>We package our meals so that the ingredients are separated. This allows for them to stay fresh for longer and if there is an item you don't care for, you can choose to not include it in your meal!</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab24">How big is each meal?</a>
                <div class="content">
                  <p>Enjoy the salads and bowls as a full meal or enjoy it as a side salad for two people!</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab25">How long will my meals last?</a>
                <div class="content">
                  <p>Our fridge life ranges from 5-7 days. You can ﬁnd a fridge life for all of our meals on our menu and listed on our labels. The number of days listed applies from the time you receive your order. You will see a sticker on our meals which is a lot number. These numbers help us with tracking and quality control of our meals. If you are reporting an issue with your meal, you can provide us with these lot numbers. The only items that you will ﬁnd the best before date sticker on will be the items that contain meat and/or egg protein. Our meals are able to last because of our patent packaging, which separates ingredients and keeps items fresher for longer!</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tab_content" data-id="tab3">
            <div class="accordion-container">
              <div class="set">
                <a href="javascript:void(0)" id="tab31">What is the referral program?</a>
                <div class="content">
                  <p>Tell your friends how much you love Inspired Go by sharing your unique discount link. When a friend places an order using your link they will receive $15 off their ﬁrst order and you will also be sent an email with a $15 discount code. Visit this link to refer your friends!</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab32">What kind of packaging do you use for meals?</a>
                <div class="content">
                  <p>At Inspired Go we believe in doing good for our bodies and the world. Sustainability is an ongoing conversation, and this means continuous change and adaptation. Our #1 grade PETE containers are 100% recyclable, made using less energy, and are made with recycled material because they can be recycled an endless amount of times. Wash your containers and recycle them!</p>
                  <p>After some serious research and investment into compostable packaging, we are avoiding the serious negative effects that these products are having on our recycling stream. Instead, we are making large investments into packaging research for the produce industry as a whole so that we are able to sustainably and ethically recycle and compost in facilities that are available to the Canadian market. We are excited to update you as strides are made in our research! You can stay up to date with new information here.</p>
                </div>
              </div>
              <div class="set">
                <a href="javascript:void(0)" id="tab33">I have a product or service and want to partner with you. How do I reach out?</a>
                <div class="content">
                  <p>You can reach out to us to tell us more by filling out this form!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <script src="https://code.jquery.com/jquery-3.6.3.min.js"></script>
  </section>
  <section id="shopify-section-template--14870472196138__440f288a-e04d-4b4a-9530-17988fbb107b" class="shopify-section img_content_section split_task_none">
    <div class="img_content_wrapper">
      <div class="img_content_band right_img">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="img_content">
                <h2>recyclable packaging</h2>
                <p>Our #1 grade PETE containers are 100% recyclable, made using less energy, made with recycled material, and we are working to do better! We are making large investments into packaging research for the produce industry as a whole. Our vision is to have all compostable packaging that actually composts in your backyard (instead of needing massive US facilities). We are excited to update you as strides are made in our research!</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="image">
                <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/new_help_packing.png?v=1672742898">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="img_content_band left_img">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="image">
                <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/new_help_packing.png?v=1672742898">
              </div>
            </div>
            <div class="col-md-6">
              <div class="img_content">
                <h2>separated ingredients</h2>
                <p>We package our salads and bowls in patent packaging that allows the ingredients to be separated. This means your meals stay fresher longer and if there is an item you don’t care for you can choose to not include it in your meal!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="img_content_band right_img">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="img_content">
                <h2>subscribe &amp; save</h2>
                <p>Want an order each week? Subscribe to Inspired Go and save 5%! You can skip a week or cancel anytime you like. You can also alter the items in your subscription every week!</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="image">
                <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/new_help_packing.png?v=1672742898">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new_banner_section" style="display:none">
      <div class="new_banner_wrapper">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="new_banner_content">
                <h2>delivery</h2>
                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam.</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="new_banner_right_img">
                <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/delivery_right_img.png?v=1672753039">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="delivery_schedule_section" style="display:none">
      <div class="delivery_schedule_wrapper">
        <div class="container">
          <h2>our delivery schedule</h2>
          <p>To learn more about ordering &amp; delivery, checkout our FAQ Page.</p>
          <div class="row">
            <div class="col-md-4">
              <div class="schedule_content">
                <div class="schedule_img">
                  <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/Calgary_img.png?v=1672753272">
                </div>
                <h4>Calgary</h4>
                <h5>order by 10pm</h5>
                <ul>
                  <li><strong>Order By</strong><strong>Delivery On</strong></li>
                  <li><span>Fri</span><span>Mon</span></li>
                  <li><span>Wed</span><span>Fri</span></li>
                  <li><span>Thu</span><span>Sun</span></li>
                </ul>
                <p>Delivery to Airdrie and Chestermere is available on Sundays.</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="schedule_content">
                <div class="schedule_img">
                  <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/Vancouver_img.png?v=1672753272">
                </div>
                <h4>Vancouver</h4>
                <h5>order by 9pm</h5>
                <ul>
                  <li><strong>Order By</strong><strong>Delivery On</strong></li>
                  <li><span>Wed</span><span>Sun</span></li>
                  <li><span>Thu</span><span>Mon</span></li>
                  <li><span>Fri</span><span>Tue</span></li>
                </ul>
                <p>Delivery to Abbotsford is available on Sundays and Mondays.</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="schedule_content">
                <div class="schedule_img">
                  <img src="https://cdn.shopify.com/s/files/1/0266/9900/5994/files/Kelowona_img.png?v=1672753272">
                </div>
                <h4>Kelowona</h4>
                <h5>order by 9pm</h5>
                <ul>
                  <li><strong>Order By</strong><strong>Delivery On</strong></li>
                  <li><span>Wed</span><span>Sun</span></li>
                  <li><span>Thu</span><span>Mon</span></li>
                </ul>
                <p>Delivery to Airdrie and Chestermere is available on Sundays.</p>
              </div>
            </div>
          </div>
          <a href="#" class="location_btn">VIEW OUR DELIVERY LOCATIONS →</a>
        </div>
      </div>
    </div>
  </section>
`;
newSTHelpMain.innerHTML = newSTHelpContent;

// Bundle promotion
class BundlePromotion extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.addToCart.bind(this));
  }

  extractProductData() {
    const json = this.querySelector("[data-bundle-products]");
    if (!json) return null;

    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      console.error("Error parsing bundle products:", error);
      return null;
    }
  }

  updateInputs() {
    const productData = this.extractProductData();
    if (!productData) return;

    const collectionGrid = document.getElementById(
      "main-collection-product-grid"
    );
    productData.products.forEach((product) => {
      const input = collectionGrid.querySelector(
        `input[data-id="${product.id}"`
      );
      if (input) input.value = Number(input.value) + product.quantity;
    });
  }

  addToCart() {
    const productData = this.extractProductData();
    if (!productData) return;

    let updates = {};
    const collectionGrid = document.getElementById(
      "main-collection-product-grid"
    );
    productData.products.forEach((product) => {
      const input = collectionGrid.querySelector(
        `input[data-id="${product.id}"`
      );
      let quantity = product.quantity;
      if (input) quantity = quantity + Number(input.value);
      updates[product.id] = quantity;
    });

    const body = {
      updates: updates,
    };

    return fetch("/cart/update.js", {
      method: "POST",

      credentials: "same-origin",
      cache: "no-store",

      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((res) => {
        this.updateInputs();
        updateCartBubbles(res);
        updateCartProgress(res);
        updateFreeShippingMessage(res.total_price / 100);
        updatePopUpMessage(res.total_price / 100);
      });
  }
}

customElements.define("bundle-promotion", BundlePromotion);
